import { routesMap } from '../../../../routes/AppRoutes';
import { Reports } from '../../../../api/apiTypes';
import { formatTitle } from '../../../../utils/Format';
import HeroSection from '../../../conduct-risk/HeroSection';

interface DataFromParent {
  report: Reports | undefined;
  title: string | undefined;
  reportId?: string;
}

const BannerBestExecution = ({ report, title, reportId }: DataFromParent) => {
  const formattedTitle = formatTitle(title);

  const resetPagination = () => {
    localStorage.removeItem('currentPage_best_execution');
  };

  return (
    <HeroSection
      title={formattedTitle}
      description="Consulta i risultati dell'analisi per questo driver."
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home', onClick: resetPagination },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution', onClick: resetPagination },
        { url: routesMap.REPORT_PAGE, title: 'Report', onClick: resetPagination },
        {
          url: routesMap.VISUALIZZA_REPORT(report?.name ?? ''),
          title: report?.name ?? '',
          state: { id: reportId },
          onClick: resetPagination,
        },
        { url: '#', title: formattedTitle },
      ]}
    />
  );
};

export default BannerBestExecution;
